/**
 * Sync history window (user setting `syncHistoryYears`).
 *
 * How many years of activity a full-history SnapTrade pull requests: a new
 * connection's first sync, a forced transactions refresh, and the refetch
 * for an option close whose opening trade is missing. Incremental syncs are
 * unaffected. SnapTrade returns only what the brokerage still retains (about
 * two years for Schwab), so a longer setting is harmless, just not always
 * fully filled.
 */

export const SYNC_HISTORY_YEARS_DEFAULT = 1;
export const SYNC_HISTORY_YEARS_MIN = 1;
export const SYNC_HISTORY_YEARS_MAX = 5;

/** The user's sync history window, or the default when unset or out of range. */
export function resolveSyncHistoryYears(settings: unknown): number {
  const value = (settings as { syncHistoryYears?: unknown } | null | undefined)?.syncHistoryYears;
  return typeof value === 'number' &&
    Number.isInteger(value) &&
    value >= SYNC_HISTORY_YEARS_MIN &&
    value <= SYNC_HISTORY_YEARS_MAX
    ? value
    : SYNC_HISTORY_YEARS_DEFAULT;
}
